import React from 'react';

import Status from './status';
import { formatDateTime } from 'helpers/formatters/date_time_formats';

import type { Import } from './types';

interface Props {
  imports?: Import[];
  showDescription?: boolean;
}

export default function DromoImports({ imports, showDescription }: Props) {
  return (
    <table className="ds-table mt-4">
      <thead>
        <tr>
          <th>Status</th>
          {showDescription && <th>Description</th>}
          <th>Started By</th>
          <th>Started At</th>
          <th>Completed At</th>
          <th>Records</th>
          <th>Errors</th>
        </tr>
      </thead>
      <tbody>
        {imports?.map(dromoImport => (
          <tr key={dromoImport.id}>
            <td><Status status={dromoImport.status} /></td>
            {showDescription && <td>{dromoImport.description}</td>}
            <td>{dromoImport.user.name}</td>
            <td>{formatDateTime(dromoImport.createdAt)}</td>
            <td>
              {(dromoImport.status === 'completed' || dromoImport.status === 'failed') &&
                formatDateTime(dromoImport.updatedAt)
              }
            </td>
            <td>{dromoImport.recordCount}</td>
            <td>{dromoImport.failureCount}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
